import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElementRef, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faTimes, faArrowDown, faArrowUp, faArrowRight, faArrowLeft, faPen, faFileImage, faStop, faPause, faPlay, faLock, faPlug, faPlus, faImages, faSync, faTable, faTrash, faEye, faClock, faInfo, faBolt, faFolderPlus, faCheck, faList, faLevelUpAlt, faPlayCircle, faFolderOpen, faVial, faVideo, faFilm, faCode, faPhotoVideo, faHome, faDesktop, faCalendar, faUsers, faFile, faUserTag, faUser, faCog, faCogs, faSignOutAlt, faImage, faEyeSlash, faVideoSlash, faRedo, faCalendarAlt, faColumns, faUpload, faCopy, faDownload, faCaretDown, faCaretUp, faCircleCheck, faCircleXmark, faCircleMinus, faEllipsisV, faMagnifyingGlassPlus, faMagnifyingGlassMinus } from '@fortawesome/free-solid-svg-icons';

/*
 **/
@Component({
  selector: 'icon',
  templateUrl: './icon.component.html'
})
export class IconComponent {
  public icons = {
    ArrowLeft: faArrowLeft,
    ArrowRight: faArrowRight,
    ArrowUp: faArrowUp,
    ArrowDown: faArrowDown,
    Bolt: faBolt,
    Calendar: faCalendar,
    CalendarAlt: faCalendarAlt,
    CaretDown: faCaretDown,
    CaretUp: faCaretUp,
    Check: faCheck,
    CircleCheck: faCircleCheck,
    CircleMinus: faCircleMinus,
    CircleXMark: faCircleXmark,
    Clock: faClock,
    Code: faCode,
    Cog: faCog,
    Cogs: faCogs,
    Columns: faColumns,
    Copy: faCopy,
    Desktop: faDesktop,
    Download: faDownload,
    EllipsesVertical: faEllipsisV,
    Eye: faEye,
    EyeSlash: faEyeSlash,
    File: faFile,
    FileImage: faFileImage,
    Film: faFilm,
    FolderOpen: faFolderOpen,
    FolderPlus: faFolderPlus,
    Home: faHome,
    Image: faImage,
    Images: faImages,
    Info: faInfo,
    List: faList,
    LevelUp: faLevelUpAlt,
    Lock: faLock,
    Pause: faPause,
    Pen: faPen,
    PhotoVideo: faPhotoVideo,
    Play: faPlay,
    PlayCircle: faPlayCircle,
    Plug: faPlug,
    Plus: faPlus,
    Redo: faRedo,
    Save: faSave,
    SignOut: faSignOutAlt,
    Stop: faStop,
    Sync: faSync,
    Table: faTable,
    Times: faTimes, // Typically used for close.
    Trash: faTrash,
    Upload: faUpload,
    User: faUser,
    Users: faUsers,
    UserTag: faUserTag,
    Video: faVideo,
    VideoSlash: faVideoSlash,
    ZoomMinus: faMagnifyingGlassMinus,
    ZoomPlus: faMagnifyingGlassPlus
  };

  constructor(private el: ElementRef) {
  }

  // ----

  _icon: string;

  get icon(): string { return this._icon; }

  @Input('icon')
  set icon(_value: string) {
    this._icon = _value;
    if (_value === undefined || _value === null || _value.length === 0) {
      throw 'No icon has been passed!';
    }
  }
}

@NgModule({
  declarations: [
    IconComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    IconComponent
  ]
})
export class IconModule { }
